import { render, staticRenderFns } from "./card-patient.vue?vue&type=template&id=75799d4d&scoped=true&"
import script from "./card-patient.vue?vue&type=script&lang=js&"
export * from "./card-patient.vue?vue&type=script&lang=js&"
import style0 from "./card-patient.vue?vue&type=style&index=0&id=75799d4d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75799d4d",
  null
  
)

export default component.exports